import { Color } from "three";

export * from "../shared/constants";

export const PLAYER_HEIGHT = 1.7;
export const PLAYER_MODEL_SCALE = 0.6;

export const DAY_LENGTH = 600;
export const START_TIME = 150;
export const DAY_SKY = new Color(0xaaeeff);
export const NIGHT_SKY = new Color(0x112233);
export const DAY_ATMOSPHERE = new Color(0xccccff);
export const NIGHT_ATMOSPHERE = new Color(0x336699);
export const REFRESH_TICK = 200;
